import React, { Component } from "react";
import { Link } from "react-router-dom";

class Error404 extends Component {
  render() {
    return (
      <>
        <div className="error-404">
          <div className="inner-content container">
            <h3 className="error-title">
              4<span></span>4
            </h3>
            <h3 className="error-text">Sidan du letade efter kunde inte hittas.</h3>
            <p>Sidan du söker har kanske tagits bort, fått ett nytt namn eller är tillfälligt otillgänglig.</p>
            <div className="clearfix">
              <Link to="/" className="btn btn-primary">
                Tillbaka Till Hemsidan
              </Link>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Error404;
